module.exports = __webpack_public_path__ + "static/media/alberto.1eb3acaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comparative/tiendamia/alberto.jpg
// module id = 1198
// module chunks = 0